import { getImageSources } from "@dotcom/dato";
import {
  AspectRatio,
  AspectRatios,
  Breakpoints,
  GalleryVariants,
  Gallery,
} from "@polestar/component-warehouse-react";

import { Section } from "~/common/components";
import { type ParsedImage } from "~/common/types";

interface Props {
  readonly imagesMobile?: ParsedImage[];
  readonly imagesTablet?: ParsedImage[];
  readonly imagesDesktop?: ParsedImage[];
  readonly imagesWithCaption?: Array<{
    caption?: string;
    imageMobile?: ParsedImage;
    imageTablet?: ParsedImage;
    imageDesktop?: ParsedImage;
  }>;
  readonly sectionSlug?: string;
}

const NewsGallerySection = ({
  imagesMobile,
  imagesTablet,
  imagesDesktop,
  imagesWithCaption,
  sectionSlug,
}: Props) => {
  if (imagesWithCaption === null) {
    return null;
  }

  const imagesToUse =
    imagesWithCaption && imagesWithCaption.length > 0
      ? imagesWithCaption
      : imagesDesktop?.map((imageDesktop, index) => {
          return {
            imageMobile: imagesMobile?.[index],
            imageTablet: imagesTablet?.[index],
            imageDesktop,
          };
        });

  const responsiveImages = imagesToUse?.map(
    ({ imageMobile, imageTablet, imageDesktop }) => {
      const { source, sources } = getImageSources({
        mobile: {
          url: imageMobile ? imageMobile.url : imageDesktop?.url,
          imageWidth: 768,
          breakpoint: Breakpoints.mobile,
        },
        tablet: {
          url: imageTablet ? imageTablet.url : imageDesktop?.url,
          imageWidth: 960,
          breakpoint: Breakpoints.tablet,
        },
        desktop: {
          url: imageDesktop?.url,
          imageWidth: 1248,
          breakpoint: Breakpoints.desktop,
        },
        desktopWide: {
          url: imageDesktop?.url,
          imageWidth: 1920,
          breakpoint: Breakpoints.desktopWide,
        },
      });

      return {
        src: source,
        sources,
        caption: imageDesktop?.title,
        alt: imageDesktop?.alt ?? "",
      };
    }
  );

  return (
    <Section media id={sectionSlug}>
      <AspectRatio
        ratio={{ mobile: AspectRatios.tall, tablet: AspectRatios.xWide }}
      >
        <Gallery
          variant={GalleryVariants.highContrastChevrons}
          content={responsiveImages ?? []}
        />
      </AspectRatio>
    </Section>
  );
};

export default NewsGallerySection;
